import request from '@/utils/request'

// 获取UKEY付款流水查询
export function getUkeyFlow(req) {
  return request({
    url: '/business/ukey',
    method: 'post',
    data: req
  })
}
// 获取交易服务费流水查询
export function getFeeFlow(req) {
  return request({
    url: '/business/service',
    method: 'post',
    data: req
  })
}
// 获取充值流水查询
export function getRechargeFlow(req) {
  return request({
    url: '/business/recharge',
    method: 'post',
    data: req
  })
}
// 获取提现流水查询
export function getWithdrawalFlow(req) {
  return request({
    url: '/business/withdrawal',
    method: 'post',
    data: req
  })
}
// 获取付款流水查询
export function getPayerFlow(req) {
  return request({
    url: '/business/pay',
    method: 'post',
    data: req
  })
}
// 获取收款流水查询
export function getPayeeFlow(req) {
  return request({
    url: '/business/collection',
    method: 'post',
    data: req
  })
}

// 前面六个流水查询的合并-上面几个接口没用了
export function getFlow(params) {
  return request({
    url: '/business/' + params.name,
    method: 'post',
    data: params.data
  })
}
// 会员转账交易审核-待审核数量
export function getFlowNew(params) {
  return request({
    url: '/business/' + params.name,
    method: 'post',
    data: params.data
  })
}

// 导出excel
export function exportTrade(req) {
  return request({
    url: '/business/export_excel',
    method: 'get',
    params: req
  })
}
// 回单下载弹窗
export function getReceiptDownload(req) {
  return request({
    url: '/business/huidan',
    method: 'post',
    data: req
  })
}
// 会员转账交易审核-详情
export function vipDetail(order_no) {
  return request({
    url: '/business/member_transfer_verify_info',
    method: 'post',
    data: { order_no: order_no }
  })
}
// 会员转账交易审核-审核
export function vipCheck(data) {
  return request({
    url: '/business/member_transfer_verify_check',
    method: 'post',
    data: data,
    formData: true
  })
}
